import cn from "classnames"
import React from "react"
import SignSVGInline from "@/common/components/sign_svg_inline"

interface ExamplePreviewProps {
  className?: string
  svg?: string | null
  svgB?: string | null
}

const ExamplePreview: React.FC<ExamplePreviewProps> = ({ className, svg, svgB }) => {
  const signClass = cn(
    "example-preview overflow-hidden [&_*]:filter-none [&_.cutline]:hidden [&_.pdfoutline]:hidden [&_svg]:h-full [&_svg]:max-h-full [&_svg]:w-full [&_svg]:max-w-full [&_svg]:overflow-visible",
    className
  )

  return (
    <>
      {svg && <SignSVGInline component="div" svg={svg} className={signClass} />}
      {svgB && <SignSVGInline component="div" svg={svgB} className={signClass} />}
    </>
  )
}

export default ExamplePreview
